/* yc-gallery-demand-20261020: only visible carousel selection and neighbours. */
(function () {
  'use strict';
  function hydrate(image, selected) {
    var src = image.getAttribute('data-yc-gallery-src');
    if (!src) return;
    image.setAttribute('fetchpriority', selected ? 'high' : 'low');
    image.setAttribute('loading', selected ? 'eager' : 'lazy');
    var srcset = image.getAttribute('data-yc-gallery-srcset');
    if (srcset) image.setAttribute('srcset', srcset);
    image.setAttribute('src', src);
    image.removeAttribute('data-yc-gallery-src');
    image.removeAttribute('data-yc-gallery-srcset');
  }
  function init() {
    var images = Array.from(document.querySelectorAll('img[data-yc-gallery-src]'));
    if (!images.length) return;
    var roots = [];
    var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var image = entry.target;
        if (image.closest('.t4s-flickity-slider')) return;
        hydrate(image, false);
        observer.unobserve(image);
      });
    }, {rootMargin: '200px 0px'}) : null;
    images.forEach(function (image) {
      var root = image.closest('.t4s-flickity-slider');
      if (root) {
        if (roots.indexOf(root) === -1) roots.push(root);
      } else if (observer) observer.observe(image);
      else hydrate(image, false);
    });
    roots.forEach(function (root) {
      var queued = false;
      function loadSelection() {
        queued = false;
        var cells = Array.from(root.querySelectorAll('[data-main-slide]'));
        var selected = root.querySelector('[data-main-slide].is-selected');
        if (!selected) return;
        var index = cells.indexOf(selected);
        [index, index - 1, index + 1].forEach(function (i) {
          var cell = cells[i];
          if (!cell) return;
          var image = cell.querySelector('img[data-yc-gallery-src]');
          if (image) hydrate(image, i === index);
        });
      }
      function schedule() {
        if (queued) return;
        queued = true;
        requestAnimationFrame(loadSelection);
      }
      new MutationObserver(schedule).observe(root, {
        subtree: true, childList: true, attributes: true,
        attributeFilter: ['class', 'aria-hidden']
      });
      loadSelection();
    });
    document.addEventListener('shopify:section:load', init, {once: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
